/**
 * Story pool: the 4 stories of each age group (tier 1 = 5–7 … tier 12 = 71–101).
 *
 * GENERATED by tekstpool/bron/maak_storypool.py from tekstpool/storypool-v1.json (step 11, 28-09-2026).
 * Do not edit by hand. Story pool version 1 is frozen once sessions are recorded with it:
 * a changed text, question or choice becomes a new pool version.
 */

export const STORY_POOL_VERSION = 1;

/** Story ids are the same in every language. */
export const STORY_POOL_SLOTS: Record<number, readonly [string, string, string, string]> = {
  1: ["1:1", "1:2", "1:5", "1:6"], // 5–7
  2: ["2:1", "2:2", "6:2", "6:1"], // 8–9
  3: ["3:1", "7:1", "7:2", "8:2"], // 10–12
  4: ["4:5", "4:6", "4:7", "4:8"], // 13–14
  5: ["10:1", "8:1", "9:1", "9:2"], // 15–16
  6: ["4:1", "4:2", "6:5", "6:6"], // 17–20
  7: ["7:3", "7:4", "7:5", "7:6"], // 21–28
  8: ["8:5", "8:6", "8:7", "8:8"], // 29–35
  9: ["9:5", "9:6", "9:7", "9:8"], // 36–45
  10: ["10:2", "10:5", "10:6", "10:7"], // 46–55
  11: ["11:1", "11:2", "11:5", "11:6"], // 56–70
  12: ["12:1", "12:2", "12:5", "12:6"], // 71–101
};
